var map = {
	"./assets/feature": [
		85284,
		5284
	],
	"./batching/feature": [
		70832,
		1622,
		7164,
		3949,
		5354,
		2988,
		7012,
		6609,
		8596,
		477,
		3961,
		656,
		9488,
		7437
	],
	"./counterfactual/feature": [
		46528,
		3949,
		1622,
		5354,
		2988,
		8174,
		7012,
		5950,
		477,
		3961,
		1810,
		8321,
		7354,
		6331,
		8201,
		5705,
		7638
	],
	"./gtf/feature": [
		30582,
		3230,
		582
	],
	"./hypernative/feature": [
		59275,
		9596,
		8321,
		8477
	],
	"./ledger/feature": [
		61681,
		7164,
		1681
	],
	"./myAccounts/feature": [
		71221,
		2988,
		8974,
		5354,
		5702,
		2690,
		8596,
		9274,
		9407,
		3602
	],
	"./nfts/feature": [
		35369,
		6660,
		3949,
		9484,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		7164,
		1065
	],
	"./oidc-auth/feature": [
		67990,
		6098,
		7990
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		61857,
		7164,
		1622,
		3949,
		5354,
		2988,
		7012,
		6609,
		5950,
		7848,
		8596,
		477,
		3961,
		656,
		9488,
		1810,
		2304,
		7858,
		8224,
		1729
	],
	"./spaces/feature": [
		24538,
		2988,
		5354,
		8974,
		3949,
		9461,
		1622,
		7164,
		7012,
		6609,
		5420,
		5909,
		3715,
		8596,
		477,
		3961,
		656,
		9488,
		9274,
		7781,
		9014
	],
	"./speedup/feature": [
		77363,
		3949,
		1622,
		477,
		2939
	],
	"./spending-limits/feature": [
		21883,
		3949,
		3483,
		5354,
		2988,
		1622,
		7164,
		8174,
		7012,
		6609,
		5950,
		7848,
		2206,
		6033,
		5420,
		8596,
		477,
		3961,
		656,
		9488,
		1810,
		8321,
		7354,
		6331,
		2304,
		8201,
		7858,
		8224,
		6810,
		9214,
		1883
	],
	"./stake/feature": [
		77754,
		7164,
		1622,
		5354,
		2988,
		3949,
		7012,
		6609,
		8596,
		477,
		3961,
		656,
		9488,
		2550
	],
	"./support-chat/feature": [
		41029,
		1029
	],
	"./swap/feature": [
		21221,
		1622,
		2148,
		1221
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./transactions/feature": [
		50374,
		1622,
		7164,
		5354,
		2988,
		3949,
		7012,
		6609,
		8596,
		477,
		3961,
		656,
		9488,
		7781,
		500
	],
	"./tx-notes/feature": [
		73322,
		3322
	],
	"./wallet/feature": [
		71993,
		1993
	],
	"./walletconnect/feature": [
		4390,
		1520,
		7164,
		7012,
		6609,
		6847,
		2266,
		4390
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;